export const HOUR_HEIGHT = 96;
export const GUTTER_WIDTH = 64;
export const MIN_COLUMN_WIDTH = 220;
// Keeps one or two locations from stretching into unreadably wide columns
export const MAX_COLUMN_WIDTH = 420;
// Fixed so a session's text can stick right below the sticky header row
export const HEADER_HEIGHT = 42;
// Only blocks this tall pin their text; shorter ones would barely move anyway
export const STICKY_MIN_HEIGHT = 400;
// Floor for a block's height so even a five-minute session stays clickable
export const MIN_BLOCK_MINUTES = 30;

// Palette excludes red (reserved for canceled/now indicators) and the
// yellow/lime hues whose text shades can't reach readable contrast
export const LOCATION_COLORS = [
  "blue",
  "teal",
  "grape",
  "orange",
  "cyan",
  "pink",
  "violet",
  "indigo",
];

// Sessions with no location share one column of their own
export const NO_LOCATION_KEY = "none";
export const NO_LOCATION_NAME = "No location";
export const NO_LOCATION_COLOR = "gray";
